import styled from 'styled-components'
import { COLORS } from 'app/constants'

export const EventsContainer = styled.div`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 32px 36px 40px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media only screen and (max-width: 1024px) {
    padding: 28px 28px 38px;
  }

  @media only screen and (max-width: 768px) {
    padding: 24px 18px 34px;
    gap: 24px;
  }

  @media only screen and (max-width: 480px) {
    padding: 20px 14px 28px;
  }
`
export const ListView = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden !important;
`
export const EventTitle = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: #000;
	text-transform: capitalize;
`
export const EventContent = styled.div`
	font-size: 14px;
	font-weight: 400;
	width: 100%;
	color: #000;
`
export const EventDate = styled.div`
	font-size: 12px;
	font-weight: 300;
	color: #000;
`

export const MetaView = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	margin-bottom: 10px;
	width: 100%;
	@media only screen and (max-width: 600px) {
		flex-direction: column;
		height: 60px;
	}
`
export const MetaTitle = styled.div`
	width: 150px;
	height: 100%;
	display: flex;
	align-items: flex-start;
	font-size: 16px;
	font-weight: 600;
	@media only screen and (max-width: 600px) {
		width: 100px;
	}
`
export const Meta = styled.div`
	flex: 1;
	display: flex;
	background-color: ${COLORS.lightGray2};
	height: 30px;
	border-radius: 5px;
	align-items: center;
	padding-left: 10px;
	cursor: pointer;
	@media only screen and (max-width: 600px) {
		width: 100%;
	}
`

